<template>
  <div>
    <top-title
      name="资产项管理"
      style="margin: 20px; min-width: 980px"
    ></top-title>

    <div class="integralEden">
      <div class="content">
        <!-- 头部导航切换 -->
        <div class="navTab">
          <span
            class="tab"
            :class="{ active: tabActive == 1 }"
            @click="jumpEvent1"
            >京豆</span
          >
          <span
            class="tab"
            :class="{ active: tabActive == 2 }"
            @click="tabActive = 2"
            >积分</span
          >
          <span
            class="tab"
            :class="{ active: tabActive == 3 }"
            @click="jumpEvent"
            >京东E卡</span
          >
          <span
            class="tab"
            :class="{ active: tabActive == 4 }"
            @click="jumpEvent2"
            >爱奇艺会员</span
          >
          <span
            class="tab"
            :class="{ active: tabActive == 5 }"
            @click="jumpEvent3"
            >plus会员</span
          >
          <span
            class="tab"
            :class="{ active: tabActive == 6 }"
            @click="jumpEvent4"
            >现金红包</span
          >
        </div>

        <!-- 京豆 -->
        <div v-show="tabActive == 1">
          <div class="topTis">
            <img
              src="@/assets/images/new_icon_waring_yellow.png"
              style="
                display: inline-block;
                float: left;
                position: absolute;
                width: 14px;
                height: 14px;
                color: #ffffff;
                margin: 3px 4px 0 3px;
              "
            />
            <div class="desc" style="margin-left: 20px">
              <p>
                1.京豆是由京东提供的权益之一，是一项灵活、有效、吸引力强的营销权益工具；
              </p>
              <p>
                2.商家可将京豆配置在会员互动、积分兑换等店铺营销活动中，提升店铺活动效果。京豆发放是直接将京豆发送到买家账户中；
              </p>
              <p>
                3.京豆使用有起用门槛，客户下单时，满足使用门槛可直接抵扣订单的商品金额。
              </p>
            </div>
          </div>
          <div class="topTisTwo">
            <div class="beans">
              <img src="@/assets/images/integralCenter/icon_jingduo.png" />
            </div>
            <div class="available">
              <p>账户可用数额</p>
              <br />
              <span style="color: #fe4d45; font-size: 18px">
                {{ availableNum }}</span
              >&nbsp;<span style="color: #999999">京豆</span>
            </div>
            <div class="freeze">
              <p>当前冻结数额</p>
              <br />
              <span style="color: #fe4d45; font-size: 18px">{{
                freezeNum
              }}</span
              >&nbsp;<span style="color: #999999">京豆</span>
            </div>
          </div>

          <input-form
            ref="i1"
            style="margin: 40px 0"
            :inputData="inputData"
            :pageName="pageName"
            @toParentVal="searchContent"
            :btnPosition="true"
          ></input-form>
          <el-button
            type="primary"
            style="margin: 0 0 40px 30px"
            v-zoom='{from:"忠诚度管理-资产项管理",name:"创建计划"}'
            @click="createPopup"

            ><img
              src="@/assets/images/member/new_establish.png"
              style="
                display: inline-block;
                float: left;
                width: 14px;
                height: 14px;
                color: #ffffff;
                margin-right: 3px;
              "
            />创建计划</el-button
          >
          <el-button v-zoom='{from:"忠诚度管理-资产项管理",name:"充值"}' @click="recharge">充值</el-button>

          <el-table
            :data="tableData"
            v-loading="tableLoading"
            style="width: 95%; margin: 0 auto"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
          >
            <template slot="empty">
              <div>
                <img src="@/assets/images/default/暂无任何数据.png" />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
            <el-table-column prop="planName" label="计划名称" width="210">
            </el-table-column>
            <el-table-column prop="quantityTotal" label="预算京豆" width="210">
            </el-table-column>
            <el-table-column
              prop="quantityBalance"
              label="剩余京豆"
              width="210"
            >
            </el-table-column>
            <el-table-column label="计划时间" width="210">
              <template slot-scope="scope">
                <span>起:{{ scope.row.startTime }}</span
                ><br />
                <span>止:{{ scope.row.endTime }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="ruleType" label="发豆规则" width="210">
              <template slot-scope="scope">
                <span v-if="scope.row.ruleType == 1"
                  >每人每天发放 {{ scope.row.sendTimes }} 次</span
                >
                <span v-if="scope.row.ruleType == 2"
                  >每人活动内发放 {{ scope.row.sendTimes }} 次</span
                >
                <!-- <span >{{ scope.row.ruleType == 1 ? '每人每天发放次数' : '每人活动内发放次数'}}</span> -->
              </template>
            </el-table-column>
            <el-table-column label="状态" width="210">
              <template slot-scope="scope">
                <span>
                  <span
                    class="dot"
                    :class="[
                      scope.row.status == '0' ? 'dot-0' : '',
                      scope.row.status == '1' ? 'dot-1' : '',
                      scope.row.status == '2' ? 'dot-2' : '',
                      scope.row.status == '3' ? 'dot-3' : '',
                    ]"
                  ></span>
                  {{ scope.row.status | statusStr }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="300">
              <template slot-scope="scope">
                <span
                  type="text"
                  @click="marketNow(scope.row)"
                  class="operation"
                  >查看详情</span
                >&nbsp;&nbsp;&nbsp;
                <el-button
                  type="text"
                  class="operation"
                  @click="marketNowDetail(scope.row)"
                  >数据明细</el-button
                >
                <el-button
                  type="text"
                  v-zoom='{from:"忠诚度管理-资产项管理-京豆",name:"停止"}'
                  @click="stopActivity(scope.row)"
                  :disabled="scope.row.status == 3"
                  >停止</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="formList.current"
            :page-sizes="[10, 30, 50, 100]"
            :page-size="formList.size"
            layout="total, sizes, prev, pager, next, jumper"
            class="pagination"
            :total="totalList"
          ></el-pagination>
        </div>

        <!-- 积分 -->
        <div v-if="tabActive == 2">
          <div v-if="pointsStatus == false">
            <div class="topTisTwo">
              <div class="beans">
                <img src="@/assets/images/integralCenter/icon_jifen.png" />
              </div>
              <div class="available">
                <p style="font-size: 16px">店铺积分未开通</p>
                <br />
                <p style="color: #666666; font-size: 14px">
                  开通并合理的设置积分规则有助您管理店铺的会员关系，增加重复购买率
                </p>
              </div>
              <el-button type="primary" class="btn" @click="openStoreIntegral"
                >开通店铺积分</el-button
              >
            </div>
          </div>
          <div v-else>
            <div class="topTisTwo">
              <div class="beans">
                <img src="@/assets/images/integralCenter/icon_jifen.png" />
              </div>
              <div class="available">
                <p style="font-size: 16px">店铺积分已开通</p>
                <br />
                <p style="color: #666666; font-size: 14px">
                  开通并合理的设置积分规则有助您管理店铺的会员关系，增加重复购买率
                </p>
              </div>
              <el-button type="primary" class="btn" @click="openStoreIntegral"
                >开通店铺积分</el-button
              >
            </div>

            <div class="boxLayer">
              <div
                class="boxSet"
                v-for="(item, index) in form"
                :key="index"
                :v-model="form"
              >
                <p>{{ item.pointsSetContent }}</p>
                <el-button
                  @click="integralSet(item.id)"
                  style="
                    border-color: #fe4d45;
                    position: absolute;
                    margin: 60px 0 0 40px;
                    color: #fe4d45;
                    font-size: 14px;
                  "
                  >{{ item.set }}</el-button
                >
                <!-- <img src=""> -->
                <div class="imgTp"><img :src="item.scr" /></div>
              </div>
            </div>
          </div>
        </div>

        <!-- 京东E卡 -->
        <div v-show="tabActive == 3">
          <div class="topTis">
            <img
              src="@/assets/images/new_icon_waring_yellow.png"
              style="
                display: inline-block;
                float: left;
                position: absolute;
                width: 14px;
                height: 14px;
                color: #ffffff;
                margin: 3px 4px 0 3px;
              "
            />
            <div class="desc" style="margin-left: 20px">
              <p>
                1.京东E卡
                ，由京东商城发行的可用于购买京东自营商品的电子卡；是京东官方为商家全新推出的一项灵活、有效的营销权益工具；
              </p>
              <p>2.商家可将E卡配置在店铺营销活动中，提升店铺活动效果。</p>
              <p>
                3.当前E卡面额为：1元，5元，20元，50元，100元，发放是直接发送到买家账户中，客户在京东购物时，可以直接抵现
                （注:仅可购买京东自营商品(部分特殊商品除外)，特殊商品以京东购卡章程规定内容为准）
              </p>
            </div>
          </div>
          <div class="topTisTwo">
            <div class="beans">
              <img src="@/assets/images/integralCenter/icon_eka.png" />
            </div>
            <div class="available">
              <p>累计充值数量</p>
              <br />
              <span style="color: #fe4d45; font-size: 18px">
                {{ quantityTotal }}</span
              >&nbsp;<span style="color: #999999">张</span>
            </div>
            <div class="freeze">
              <p>冻结数量</p>
              <br />
              <span style="color: #fe4d45; font-size: 18px">{{
                quantityFrozen
              }}</span
              >&nbsp;<span style="color: #999999">张</span>
            </div>
            <div class="count">
              <p>剩余数量</p>
              <br />
              <span style="color: #fe4d45; font-size: 18px">{{
                quantityBalance
              }}</span
              >&nbsp;<span style="color: #999999">张</span>
            </div>
          </div>

          <input-form
            ref="i2"
            style="margin: 40px 0"
            :inputData="inputDataTwo"
            @toParentVal="searchContentTwo"
            :btnPosition="true"
          ></input-form>
          <el-button
            type="primary"
            style="margin: 0 0px 40px 30px"
            v-zoom='{from:"忠诚度管理-资产项管理",name:"创建计划"}'
            @click="createPopup"
            ><img
              src="@/assets/images/member/new_establish.png"
              style="
                display: inline-block;
                float: left;
                width: 14px;
                height: 14px;
                color: #ffffff;
                margin-right: 3px;
              "
            />创建计划</el-button
          >
          <el-button v-zoom='{from:"忠诚度管理-资产项管理",name:"充值"}' @click="recharge">充值</el-button>

          <el-table
            :data="tableDataTwo"
            v-loading="tableLoading"
            style="width: 95%; margin: 0 auto"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
          >
            <template slot="empty">
              <div>
                <img src="@/assets/images/default/暂无任何数据.png" />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
            <el-table-column prop="planName" label="计划名称" width="200">
            </el-table-column>
            <el-table-column prop="quota" label="面额" width="180">
            </el-table-column>
            <el-table-column prop="quantityTotal" label="发行量" width="180">
            </el-table-column>
            <el-table-column label="已发放" width="180">
              <template slot-scope="scope">
                <span>{{ scope.row.quantityActual }}</span>
              </template>
            </el-table-column>
            <el-table-column label="剩余量" width="180">
              <template slot-scope="scope">
                <span>{{ scope.row.quantityBalance }}</span>
              </template>
            </el-table-column>
            <el-table-column label="计划时间" width="200">
              <template slot-scope="scope">
                <span>起:{{ scope.row.startTime }}</span
                ><br />
                <span>止:{{ scope.row.endTime }}</span>
              </template>
            </el-table-column>
            <el-table-column label="状态" width="200">
              <template slot-scope="scope">
                <span>
                  <span
                    class="dot"
                    :class="[
                      scope.row.status == '0' ? 'dot-0' : '',
                      scope.row.status == '1' ? 'dot-1' : '',
                      scope.row.status == '2' ? 'dot-2' : '',
                      scope.row.status == '3' ? 'dot-3' : '',
                    ]"
                  ></span>
                  {{ scope.row.status | statusStr }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="300">
              <template slot-scope="scope">
                <span
                  type="text"
                  @click="marketNowSet(scope.row)"
                  v-zoom='{from:"忠诚度管理-资产项管理-京豆E卡",name:"修改"}'
                  class="operation"
                  >修改</span
                >&nbsp;&nbsp;&nbsp;
                <el-button
                  v-if="scope.row.status == '3'"
                  type="text"
                  style="color: #cccccc; width: 60px; cursor: pointer"
                  >停止</el-button
                >
                <el-button
                  v-else
                  type="text"
                  v-zoom='{from:"忠诚度管理-资产项管理-京豆E卡",name:"停止"}'
                  @click="marketNowStop(scope.row)"
                  class="operation"
                  style="width: 60px"
                  >停止</el-button
                >
                <el-button
                  type="text"
                  @click="marketNowDetail(scope.row)"
                  class="operation"
                  >数据明细</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="formList.current"
            :page-sizes="[10, 30, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            class="pagination"
            :total="totalList"
          ></el-pagination>
        </div>
        <!-- 爱奇艺会员 -->
        <div v-show="tabActive == 4">
          <div class="topTis">
            <img
              src="@/assets/images/new_icon_waring_yellow.png"
              style="
                display: inline-block;
                float: left;
                position: absolute;
                width: 14px;
                height: 14px;
                color: #ffffff;
                margin: 3px 4px 0 3px;
              "
            />
            <div class="desc" style="margin-left: 20px">
              <p>
                1.爱奇艺京东自营独家授权的爱奇艺视频会员权益，价格为行业内最低，性价比极高。
                客户兑换爱奇艺会员后可享受爱奇艺海量精品内容和极致视听体验；
              </p>
              <p>
                2.商家可将爱奇艺会员配置在店铺营销活动中，提升店铺活动效果。
              </p>
              <p>
                3.现有爱奇艺会员包括黄金VIP年卡，半年卡，季卡，月卡四类，活动中获得的爱艺奇会员卡将以激活码的方式发放到买家京东账户中，由买家提取到爱奇艺账户中兑换使用，激活码兑换期限为截至2019年12月31日~
              </p>
            </div>
          </div>
          <div class="topTisTwo">
            <div class="beans">
              <img src="@/assets/images/integralCenter/icon_aiqiy.png" />
            </div>
            <div class="available">
              <p>累计充值数量</p>
              <br />
              <span style="color: #fe4d45; font-size: 18px">
                {{ quantityTotal }}</span
              >&nbsp;<span style="color: #999999">张</span>
            </div>
            <div class="freeze">
              <p>冻结数量</p>
              <br />
              <span style="color: #fe4d45; font-size: 18px">{{
                quantityFrozen
              }}</span
              >&nbsp;<span style="color: #999999">张</span>
            </div>
            <div class="count">
              <p>剩余数量</p>
              <br />
              <span style="color: #fe4d45; font-size: 18px">{{
                quantityBalance
              }}</span
              >&nbsp;<span style="color: #999999">张</span>
            </div>
          </div>

          <input-form
          ref="i3"
            style="margin: 40px 0"
            :inputData="inputDataTwo"
            @toParentVal="searchContentTwo"
            :btnPosition="true"
          ></input-form>
          <el-button
            type="primary"
            style="margin: 0 0px 40px 30px"
            v-zoom='{from:"忠诚度管理-资产项管理",name:"创建计划"}'
            @click="createPopup"
            ><img
              src="@/assets/images/member/new_establish.png"
              style="
                display: inline-block;
                float: left;
                width: 14px;
                height: 14px;
                color: #ffffff;
                margin-right: 3px;
              "
            />创建计划</el-button
          >
          <el-button v-zoom='{from:"忠诚度管理-资产项管理",name:"充值"}' @click="recharge">充值</el-button>

          <el-table
            :data="tableDataTwo"
            v-loading="tableLoading"
            style="width: 95%; margin: 0 auto"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
          >
            <template slot="empty">
              <div>
                <img src="@/assets/images/default/暂无任何数据.png" />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
            <el-table-column prop="planName" label="计划名称" width="200">
            </el-table-column>
            <el-table-column prop="quota" label="面额" width="180">
            </el-table-column>
            <el-table-column prop="quantityTotal" label="发行量" width="180">
            </el-table-column>
            <el-table-column label="已发放" width="180">
              <template slot-scope="scope">
                <span>{{ scope.row.quantityActual }}</span>
              </template>
            </el-table-column>
            <el-table-column label="剩余量" width="180">
              <template slot-scope="scope">
                <span>{{ scope.row.quantityBalance }}</span>
              </template>
            </el-table-column>
            <el-table-column label="计划时间" width="200">
              <template slot-scope="scope">
                <span>起:{{ scope.row.startTime }}</span
                ><br />
                <span>止:{{ scope.row.endTime }}</span>
              </template>
            </el-table-column>
            <el-table-column label="状态" width="200">
              <template slot-scope="scope">
                <span>
                  <span
                    class="dot"
                    :class="[
                      scope.row.status == '0' ? 'dot-0' : '',
                      scope.row.status == '1' ? 'dot-1' : '',
                      scope.row.status == '2' ? 'dot-2' : '',
                      scope.row.status == '3' ? 'dot-3' : '',
                    ]"
                  ></span>
                  {{ scope.row.status | statusStr }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="300">
              <template slot-scope="scope">
                <span
                  type="text"
                  @click="marketNowSet(scope.row)"
                  v-zoom='{from:"忠诚度管理-资产项管理-爱奇艺",name:"修改"}'
                  class="operation"
                  >修改</span
                >&nbsp;&nbsp;&nbsp;
                <el-button
                  v-if="scope.row.status == '3'"
                  type="text"
                  style="color: #cccccc; width: 60px; cursor: pointer"
                  >停止</el-button
                >
                <el-button
                  v-else
                  type="text"
                  @click="marketNowStop(scope.row)"
                  v-zoom='{from:"忠诚度管理-资产项管理-爱奇艺",name:"停止"}'
                  class="operation"
                  style="width: 60px"
                  >停止</el-button
                >
                <el-button
                  type="text"
                  @click="marketNowDetail(scope.row)"
                  class="operation"
                  >数据明细</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="formList.current"
            :page-sizes="[10, 30, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            class="pagination"
            :total="totalList"
          ></el-pagination>
        </div>
        <!-- plus会员 -->
        <div v-show="tabActive == 5">
          <div class="topTis">
            <img
              src="@/assets/images/new_icon_waring_yellow.png"
              style="
                display: inline-block;
                float: left;
                position: absolute;
                width: 14px;
                height: 14px;
                color: #ffffff;
                margin: 3px 4px 0 3px;
              "
            />
            <div class="desc" style="margin-left: 20px">
              <p>
                1.PLUS会员是京东向核心客户提供的会员特权服务，包含购物回馈、自营免运费、专享商品等的会员服务；
              </p>
              <p>2.商家可将PLUS会员配置在店铺营销活动中，提升店铺活动效果。</p>
              <p>
                3.活动中获得的PLUS会员卡将以激活码的方式发放到买家京东账户中，激活成功后即可获得365天PLUS有效期
                （激活有效期为权益采买后365天内）
              </p>
            </div>
          </div>
          <div class="topTisTwo">
            <div class="beans">
              <img src="@/assets/images/integralCenter/icon_plus.png" />
            </div>
            <div class="available">
              <p>累计充值数量</p>
              <br />
              <span style="color: #fe4d45; font-size: 18px">
                {{ quantityTotal }}</span
              >&nbsp;<span style="color: #999999">张</span>
            </div>
            <div class="freeze">
              <p>冻结数量</p>
              <br />
              <span style="color: #fe4d45; font-size: 18px">{{
                quantityFrozen
              }}</span
              >&nbsp;<span style="color: #999999">张</span>
            </div>
            <div class="count">
              <p>剩余数量</p>
              <br />
              <span style="color: #fe4d45; font-size: 18px">{{
                quantityBalance
              }}</span
              >&nbsp;<span style="color: #999999">张</span>
            </div>
          </div>

          <input-form
            ref="i4"
            style="margin: 40px 0"
            :inputData="inputDataTwo"
            @toParentVal="searchContentTwo"
            :btnPosition="true"
          ></input-form>
          <el-button
            type="primary"
            style="margin: 0 0px 40px 30px"
            @click="createPopup"
            v-zoom='{from:"忠诚度管理-资产项管理",name:"创建计划"}'
            ><img
              src="@/assets/images/member/new_establish.png"
              style="
                display: inline-block;
                float: left;
                width: 14px;
                height: 14px;
                color: #ffffff;
                margin-right: 3px;
              "
            />创建计划</el-button
          >
          <el-button v-zoom='{from:"忠诚度管理-资产项管理",name:"充值"}' @click="recharge">充值</el-button>

          <el-table
            :data="tableDataTwo"
            v-loading="tableLoading"
            style="width: 95%; margin: 0 auto"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
          >
            <template slot="empty">
              <div>
                <img src="@/assets/images/default/暂无任何数据.png" />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
            <el-table-column prop="planName" label="计划名称" width="200">
            </el-table-column>
            <el-table-column prop="quota" label="面额" width="180">
            </el-table-column>
            <el-table-column prop="quantityTotal" label="发行量" width="180">
            </el-table-column>
            <el-table-column label="已发放" width="180">
              <template slot-scope="scope">
                <span>{{ scope.row.quantityActual }}</span>
              </template>
            </el-table-column>
            <el-table-column label="剩余量" width="180">
              <template slot-scope="scope">
                <span>{{ scope.row.quantityBalance }}</span>
              </template>
            </el-table-column>
            <el-table-column label="计划时间" width="200">
              <template slot-scope="scope">
                <span>起:{{ scope.row.startTime }}</span
                ><br />
                <span>止:{{ scope.row.endTime }}</span>
              </template>
            </el-table-column>
            <el-table-column label="状态" width="200">
              <template slot-scope="scope">
                <span>
                  <span
                    class="dot"
                    :class="[
                      scope.row.status == '0' ? 'dot-0' : '',
                      scope.row.status == '1' ? 'dot-1' : '',
                      scope.row.status == '2' ? 'dot-2' : '',
                      scope.row.status == '3' ? 'dot-3' : '',
                    ]"
                  ></span>
                  {{ scope.row.status | statusStr }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="300">
              <template slot-scope="scope">
                <span
                  type="text"
                  @click="marketNowSet(scope.row)"
                  v-zoom='{from:"忠诚度管理-资产项管理-plus会员",name:"修改"}'
                  class="operation"
                  >修改</span
                >&nbsp;&nbsp;&nbsp;
                <el-button
                  v-if="scope.row.status == '3'"
                  type="text"
                  style="color: #cccccc; width: 60px; cursor: pointer"
                  >停止</el-button
                >
                <el-button
                  v-else
                  type="text"
                  @click="marketNowStop(scope.row)"
                  v-zoom='{from:"忠诚度管理-资产项管理-plus会员",name:"停止"}'
                  class="operation"
                  style="width: 60px"
                  >停止</el-button
                >
                <el-button
                  type="text"
                  @click="marketNowDetail(scope.row)"
                  class="operation"
                  >数据明细</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="formList.current"
            :page-sizes="[10, 30, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            class="pagination"
            :total="totalList"
          ></el-pagination>
        </div>
        <!-- 现金红包 -->
        <div v-show="tabActive == 6">
          <div class="topTis">
            <img
              src="@/assets/images/new_icon_waring_yellow.png"
              style="
                display: inline-block;
                float: left;
                position: absolute;
                width: 14px;
                height: 14px;
                color: #ffffff;
                margin: 3px 4px 0 3px;
              "
            />
            <div class="desc" style="margin-left: 20px">
              <p>
                1.红包是由京东提供的权益之一，是京东官方为商家全新推出的一项灵活、有效的营销权益工具；
              </p>
              <p>
                2.商家可将红包配置在抽奖、会员积分商城兑换等店铺营销活动中，提升店铺活动效果。红包发放是直接将红包发送到买家账户中；
              </p>
              <p>
                3.在活动有效期内，客户领取红包后，可以无门槛使用，直接抵扣订单的商品金额。
              </p>
            </div>
          </div>
          <div class="topTisTwo">
            <div class="beans">
              <img src="@/assets/images/integralCenter/icon_honbao.png" />
            </div>
            <div class="available">
              <p>累计充值数量</p>
              <br />
              <span style="color: #fe4d45; font-size: 18px">
                {{ quantityTotal }}</span
              >&nbsp;<span style="color: #999999">{{ unit }}</span>
            </div>
            <div class="freeze">
              <p>冻结数量</p>
              <br />
              <span style="color: #fe4d45; font-size: 18px">{{
                quantityFrozen
              }}</span
              >&nbsp;<span style="color: #999999">{{ unit }}</span>
            </div>
            <div class="count">
              <p>剩余数量</p>
              <br />
              <span style="color: #fe4d45; font-size: 18px">{{
                quantityBalance
              }}</span
              >&nbsp;<span style="color: #999999">{{ unit }}</span>
            </div>
          </div>

          <input-form
          ref="i5"
            style="margin: 40px 0"
            :inputData="inputDataThree"
            @toParentVal="searchContentThree"
            :btnPosition="true"
          ></input-form>
          <el-button
            type="primary"
            style="margin: 0 0px 40px 30px"
            @click="createPopup"
            v-zoom='{from:"忠诚度管理-资产项管理",name:"创建计划"}'
            ><img
              src="@/assets/images/member/new_establish.png"
              style="
                display: inline-block;
                float: left;
                width: 14px;
                height: 14px;
                color: #ffffff;
                margin-right: 3px;
              "
            />创建计划</el-button
          >
          <el-button v-zoom='{from:"忠诚度管理-资产项管理",name:"充值"}' @click="recharge">充值</el-button>

          <el-table
            :data="tableDataThree"
            v-loading="tableLoading"
            style="width: 95%; margin: 0 auto"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
          >
            <template slot="empty">
              <div>
                <img src="@/assets/images/default/暂无任何数据.png" />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
            <el-table-column prop="planName" label="计划名称" width="200">
            </el-table-column>
            <el-table-column
              prop="quantityAmount"
              label="发放总金额"
              width="180"
            >
            </el-table-column>
            <el-table-column prop="quantityTotal" label="发行量" width="200">
            </el-table-column>
            <el-table-column label="已发放" width="200">
              <template slot-scope="scope">
                <span>{{ scope.row.quantityActual }}</span>
              </template>
            </el-table-column>
            <el-table-column label="计划时间" width="250">
              <template slot-scope="scope">
                <span>起:{{ scope.row.startTime }}</span
                ><br />
                <span>止:{{ scope.row.endTime }}</span>
              </template>
            </el-table-column>
            <el-table-column label="状态" width="200">
              <template slot-scope="scope">
                <span>
                  <span
                    class="dot"
                    :class="[
                      scope.row.status == '0' ? 'dot-0' : '',
                      scope.row.status == '1' ? 'dot-1' : '',
                      scope.row.status == '2' ? 'dot-2' : '',
                      scope.row.status == '3' ? 'dot-3' : '',
                    ]"
                  ></span>
                  {{ scope.row.status | statusStr }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="300">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.status == '3'"
                  type="text"
                  style="color: #cccccc; width: 60px; cursor: pointer"
                  >停止</el-button
                >
                <el-button
                  v-else
                  type="text"
                  @click="marketStop(scope.row)"
                  class="operation"
                  style="width: 60px"
                  v-zoom='{from:"忠诚度管理-资产项管理-现金红包",name:"停止"}'
                  >停止</el-button
                >&nbsp;&nbsp;&nbsp;
                <el-button
                  type="text"
                  @click="marketNowDetail(scope.row)"
                  class="operation"
                  >数据明细</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="formList.current"
            :page-sizes="[10, 30, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            class="pagination"
            :total="totalList"
          ></el-pagination>
        </div>

        <!-- 创建弹窗 -->
        <el-dialog
          :title="dialogTitle"
          :visible.sync="dialogFormVisible"
          destroy-on-close
          @close="dialogFormCancel"
        >
          <div class="topTis" v-if="tabActive == 3">
            <img
              src="@/assets/images/new_icon_reminder.png"
              style="
                display: inline-block;
                float: left;
                position: absolute;
                width: 14px;
                height: 14px;
                color: #ffffff;
                margin: 3px 4px 0 3px;
              "
            />
            <div class="desc" style="margin-left: 20px">
              <p>
                1、计划创建成功后，计划时间默认为当前时间至软件到期时间，软件到期后会自动结束计划，支持手动结束计划。
              </p>
              <p>
                2、进行中的计划会预先冻结E卡，在计划结束后会自动解冻计划中的剩余E卡，返回至余量中。
              </p>
              <p>3、计划一旦创建成功，不支持修改，请谨慎设置。</p>
            </div>
          </div>
          <div class="topTis" v-if="tabActive == 4">
            <img
              src="@/assets/images/new_icon_reminder.png"
              style="
                display: inline-block;
                float: left;
                position: absolute;
                width: 14px;
                height: 14px;
                color: #ffffff;
                margin: 3px 4px 0 3px;
              "
            />
            <div class="desc" style="margin-left: 20px">
              <p>
                1、计划创建成功后，计划时间默认为当前时间至软件到期时间，软件到期后会自动结束计划，支持手动结束计划。
              </p>
              <p>
                2、进行中的计划会预先冻结爱奇艺会员卡，在计划结束后会自动解冻计划中的剩余会员卡，返回至余量中。
              </p>
              <p>
                3、计划创建成功，不支持修改，请谨慎设置。爱奇艺会员卡单价：15.9元/月，46.5元/季，86.5元/半年，158.5元/年
              </p>
            </div>
          </div>
          <div class="topTis" v-if="tabActive == 5">
            <img
              src="@/assets/images/new_icon_reminder.png"
              style="
                display: inline-block;
                float: left;
                position: absolute;
                width: 14px;
                height: 14px;
                color: #ffffff;
                margin: 3px 4px 0 3px;
              "
            />
            <div class="desc" style="margin-left: 20px">
              <p>
                1、计划创建成功后，计划时间默认为当前时间至软件到期时间，软件到期后会自动结束计划，支持手动结束计划。
              </p>
              <p>
                2、进行中的计划会预先冻结PLUS卡，在计划结束后会自动解冻计划中的剩余PLUS卡，返回至余量中。
              </p>
              <p>
                3、计划一旦创建成功，不支持修改，请谨慎设置。年卡单价：188元/年
              </p>
            </div>
          </div>
          <div class="topTis" v-if="tabActive == 6">
            <img
              src="@/assets/images/new_icon_waring_yellow.png"
              style="
                display: inline-block;
                float: left;
                position: absolute;
                width: 14px;
                height: 14px;
                color: #ffffff;
                margin: 3px 4px 0 3px;
              "
            />
            <div class="desc" style="margin-left: 20px">
              <p>
                1.红包是由京东提供的权益之一，是京东官方为商家全新推出的一项灵活、有效的营销权益工具；
              </p>
              <p>
                2.商家可将红包配置在抽奖、会员积分商城兑换等店铺营销活动中，提升店铺活动效果。红包发放是直接将红包发送到买家账户中；
              </p>
              <p>
                3.在活动有效期内，客户领取红包后，可以无门槛使用，直接抵扣订单的商品金额。
              </p>
            </div>
          </div>
          <el-form
            :model="formSet"
            :rules="rules"
            ref="formSet"
            label-width="140px"
            class="demo-ruleForm"
          >
            <el-form-item label="计划名称:" prop="planName">
              <el-input v-model="formSet.planName"></el-input>
            </el-form-item>
            <el-form-item label="活动时间:" required>
              <div class="my_select_time">
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="formSet.startTime"
                  type="datetime"
                  :placeholder="'选择日期时间'"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 120px; font-size: 12px"
                  class="time1"
                  :clearable="false"
                ></el-date-picker>
                <div class="time_to_text">至</div>
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="formSet.endTime"
                  type="datetime"
                  :placeholder="'选择日期时间'"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 145px; font-size: 12px"
                  class="time2"
                  :clearable="false"
                ></el-date-picker>
                <i
                  class="el-icon-circle-close date_icon1"
                  @click="clearTimeSendTime()"
                ></i>
                <img
                  src="@/assets/images/select_date.svg"
                  alt
                  class="date_icon2"
                />
              </div>
            </el-form-item>
            <el-form-item
              label="单份红包金额:"
              prop="quota"
              v-if="tabActive == 6"
            >
              <el-input
                v-model="formSet.quota"
                style="width: 180px"
                @blur="checkputn1"
                @input.native="checkputn2"
              >
              </el-input>
              元 <span>最低为0.1元</span>
            </el-form-item>
            <el-form-item
              label="红包数量:"
              prop="quantityTotal"
              v-if="tabActive == 6"
            >
              <el-input
                v-model.number="formSet.quantityTotal"
                style="width: 180px"
                @input.native="checkputn"
              ></el-input>
              份
              <p>提示:红包活动的最小成本为 1 元</p>
            </el-form-item>
            <el-form-item
              label="选择E卡面值:"
              prop="itemId"
              v-if="tabActive == 3"
            >
              <el-select
                v-model="formSet.itemId"
                placeholder="请选择"
                @change="eKaChange"
              >
                <el-option value="2" label="1元"
                  ><span>1元 (剩余 {{ eKaCount.one }} 张)</span></el-option
                >
                <el-option value="3" label="5元"
                  ><span>5元 (剩余 {{ eKaCount.five }} 张)</span></el-option
                >
                <el-option value="4" label="20元"
                  ><span>20元 (剩余 {{ eKaCount.twenty }} 张)</span></el-option
                >
                <el-option value="5" label="50元"
                  ><span>50元 (剩余 {{ eKaCount.fifty }} 张)</span></el-option
                >
                <el-option value="6" label="100元"
                  ><span
                    >100元 (剩余 {{ eKaCount.hundred }} 张)</span
                  ></el-option
                >
              </el-select>
            </el-form-item>
            <el-form-item
              label="爱奇艺会员面值:"
              prop="itemId"
              v-if="tabActive == 4"
            >
              <el-select
                v-model="formSet.itemId"
                placeholder="请选择"
                @change="eKaChange"
              >
                <el-option label="月卡" value="8"
                  ><span>月卡 (剩余 {{ aqyiCount.yuka }} 张)</span></el-option
                >
                <el-option label="季卡" value="12"
                  ><span>季卡 (剩余 {{ aqyiCount.jika }} 张)</span></el-option
                >
                <el-option label="半年卡" value="13"
                  ><span
                    >半年卡 (剩余 {{ aqyiCount.bannianka }} 张)</span
                  ></el-option
                >
                <el-option label="年卡" value="14"
                  ><span>年卡 (剩余 {{ aqyiCount.nianka }} 张)</span></el-option
                >
              </el-select>
            </el-form-item>
            <el-form-item
              label="plus会员面值:"
              prop="itemId"
              v-if="tabActive == 5"
            >
              <el-select
                v-model="formSet.itemId"
                placeholder="请选择"
                @change="eKaChange"
              >
                <el-option label="年卡" value="7"
                  ><span>年卡 (剩余 {{ plusCountAA }} 张)</span></el-option
                >
              </el-select>
            </el-form-item>
            <el-form-item
              label="计划内容:"
              prop="descprition"
              v-if="tabActive == 1"
            >
              <el-input
                type="textarea"
                v-model="formSet.descprition"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="京豆预算额:"
              prop="quantityTotal"
              v-if="tabActive == 1"
            >
              <el-input
                v-model.number="formSet.quantityTotal"
                style="width: 180px"
                @input.native="checkputn"
              ></el-input>
              个京豆 (价值
              <span style="color: #fe4d45" v-if="formSet.quantityTotal">{{
                formSet.quantityTotal / 100
              }}</span>
              元)
            </el-form-item>
            <el-form-item
              label="京东E卡预算额:"
              prop="quantityTotal"
              v-if="tabActive == 3"
            >
              <el-input
                v-model="formSet.quantityTotal"
                @input.native="checkputn"
                @change="eKaChange"
                style="width: 180px"
              ></el-input>
              张 (价值
              <span style="color:#fe4d45">{{ eKaCount.all }}</span> 元)&nbsp;
              <span style="color: #fe4d45; cursor: pointer">刷新</span>
            </el-form-item>
            <el-form-item
              label="发行量:"
              prop="quantityTotal"
              v-if="tabActive == 4 || tabActive == 5"
            >
              <el-input
                v-model="formSet.quantityTotal"
                @change="eKaChange"
                @input.native="checkputn"
                style="width: 180px"
              ></el-input>
              份&nbsp;
              <span>仅支持输入正整数</span>
            </el-form-item>
            <el-form-item
              label="计划描述:"
              prop="descprition"
              v-if="
                tabActive == 3 ||
                  tabActive == 4 ||
                  tabActive == 5 ||
                  tabActive == 6
              "
            >
              <el-input
                type="textarea"
                v-model="formSet.descprition"
              ></el-input>
            </el-form-item>
            <p style="width: 90%; margin: 0 auto" v-if="tabActive == 3">
              提示：京东E卡每次只能发放1张，当前京东E卡计划的最高预算费用：<span
                style="color:#fe4d45"
                >{{ eKaCount.all }}</span
              >
              元，活动流量不可控，为避免因奖品发完活动提前结束引起客诉，请仔细核对当前活动内容与活动规则设置，明确活动成本预算；
            </p>
            <el-form-item
              label="预算总额:"
              prop="quantityTotal"
              v-if="tabActive == 4 || tabActive == 5 || tabActive == 6"
            >
              <p v-if="tabActive == 4">
                <span style="color: #fe4d45">{{ eKaCount.all }}</span> 元 <br />
                当前爱奇艺会员计划最高预算费用
                <span style="color: #fe4d45">{{ eKaCount.all }}</span> 元，
                活动流量不可控，为避免奖品发完活动提前结束引起客户投诉，请仔细核对当前活动内容与活动规则设置，明确活动成本预算
              </p>
              <p v-if="tabActive == 5">
                <span style="color: #fe4d45">{{ eKaCount.all }}</span> 元 <br />
                当前PLUS会员计划最高预算费用：<span style="color: #fe4d45">{{
                  eKaCount.all
                }}</span>
                元，活动流量不可控，为避免奖品发完活动提前结束引起客户投诉，请仔细核对当前活动内容与活动规则设置，明确活动成本预算
              </p>
              <p v-if="tabActive == 6">
                <span
                  style="color: #fe4d45"
                  v-if="formSet.quantityTotal && formSet.quota"
                  >{{
                    ((Number(formSet.quota) * 1000 * formSet.quantityTotal) /
                      1000)
                      | showNumber
                  }}
                </span>
                元 <br />
                当前京东红包计划最高预算费用：<span
                  style="color: #fe4d45"
                  v-if="formSet.quantityTotal && formSet.quota"
                  >{{
                    ((Number(formSet.quota) * 1000 * formSet.quantityTotal) /
                      1000)
                      | showNumber
                  }}
                </span>
                元，活动流量不可控，为避免奖品发完活动提前结束引起客户投诉，请仔细核对当前活动内容与活动规则设置，明确活动成本预算
              </p>
            </el-form-item>
            <span
              style="margin-left: 50px"
              v-if="tabActive == 4 || tabActive == 5 || tabActive == 6"
              >您的余额不足，请
              <span style="color: #fe4d45; cursor: pointer" @click="recharge"
                >点击充值></span
              ></span
            >
            <el-form-item
              label="发豆规则:"
              prop="ruleType"
              v-if="tabActive == 1"
            >
              <el-radio-group v-model="formSet.ruleType">
                <el-radio label="1">每人每天发放次数</el-radio>
                <el-radio label="2">每人活动内发放次数</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="发豆次数:"
              prop="sendTimes"
              v-if="tabActive == 1"
            >
              <el-input
                v-model="formSet.sendTimes"
                style="width: 180px"
                @input.native="checkputn20"
              ></el-input>
              <span>（发豆次数最多20）</span>
            </el-form-item>
          </el-form>

          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormCancel">取 消</el-button>
            <el-button type="primary" @click="dialogFormSet">确 定</el-button>
          </div>
        </el-dialog>
        <!-- 京豆详情弹窗 -->
        <el-dialog title="详情" :visible.sync="dialogTableJingduo">
          <el-form :model="rowdialog" label-width="140px">
            <el-form-item label="计划名称:" required>
              <el-input v-model="rowdialog.planName" readonly></el-input>
            </el-form-item>
            <el-form-item label="活动时间:" required>
              <div class="my_select_time">
                <el-date-picker
                  disabled
                  prefix-icon="no_icon"
                  v-model="rowdialog.startTime"
                  type="datetime"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 120px; font-size: 12px"
                  class="time1"
                  :clearable="false"
                ></el-date-picker>
                <div class="time_to_text">至</div>
                <el-date-picker
                  disabled
                  prefix-icon="no_icon"
                  v-model="rowdialog.endTime"
                  type="datetime"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 145px; font-size: 12px"
                  class="time2"
                  :clearable="false"
                ></el-date-picker>
                <i class="el-icon-circle-close date_icon1"></i>
                <img
                  src="@/assets/images/select_date.svg"
                  alt
                  class="date_icon2"
                />
              </div>
            </el-form-item>
            <el-form-item label="计划内容:" required>
              <el-input
                readonly
                type="textarea"
                v-model="rowdialog.descprition"
              ></el-input>
            </el-form-item>

            <el-form-item label="京豆预算额:" required>
              <el-input
                readonly
                v-model="rowdialog.quantityTotal"
                style="width: 180px"
              ></el-input>
              个京豆 (价值
              <span style="color: #fe4d45; cursor: pointer">{{
                rowdialog.quantityTotal / 100
              }}</span>
              元)
            </el-form-item>
            <el-form-item label="发豆规则:" required>
              <el-radio-group v-model="rowdialog.ruleType" disabled>
                <el-radio label="1">每人每天发放次数</el-radio>
                <el-radio label="2">每人活动内发放次数</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="发豆次数:" required>
              <el-input
                readonly
                v-model="rowdialog.sendTimes"
                style="width: 180px"
              ></el-input>
              <span>（发豆次数最多20）</span>
            </el-form-item>
          </el-form>
        </el-dialog>
        <!-- 京豆发放明细弹窗 -->
        <el-dialog title="数据明细" :visible.sync="dialogDistribution">
          <input-form
            style="margin: 40px 0"
            :inputData="inputDataDetail"
            @toParentVal="searchContentDetail"
          ></input-form>
          <el-table
            :data="gridDataList"
            style="width: 90%; margin: 0 auto"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
          >
            <el-table-column
              property="memberNick"
              label="参与人员"
              width="240"
            ></el-table-column>
            <el-table-column
              property="sendTime"
              label="发送/领取时间"
              width="240"
            ></el-table-column>
            <el-table-column
              property="quota"
              label="面额"
              v-if="tabActive != 1"
            ></el-table-column>
            <el-table-column
              property="sendAmount"
              label="发送数量"
              v-if="tabActive != 6"
            ></el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="formList.current"
            :page-sizes="[10, 30, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            class="pagination"
            :total="totalList"
          ></el-pagination>
        </el-dialog>

        <!-- 资产修改弹窗 -->
        <el-dialog
          title="修改结束时间"
          :visible.sync="dialogRevise"
          width="500px"
        >
          &nbsp;&nbsp;&nbsp;结束时间:&nbsp;&nbsp;&nbsp;
          <el-date-picker
            prefix-icon="no_icon"
            v-model="formRevise.endTime"
            type="datetime"
            :placeholder="'选择日期时间'"
            size="small"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 180px; font-size: 12px; margin-right: 80px"
            class="time1"
            :clearable="false"
          ></el-date-picker>
          <el-button type="primary" @click="modifyConfirmation">确定</el-button>
        </el-dialog>

        <!-- 资产停止弹框 -->
        <el-dialog
          title="提示"
          :visible.sync="outerVisible"
          width="400px"
          :before-close="closehandleDelete"
          ><img
            src="@/assets/images/tips_icon.png"
            class="tips"
            style="
              margin: 6px 0px 0px 110px;
              position: absolute;
              width: 22px;
              height: 22px;
            "
          />
          <span
            style="
              position: absolute;
              margin: 10px 0px 0px 140px;
              font-size: 14px;
            "
            >是否停止计划？</span
          >
          <span slot="footer" class="buttonBox">
            <el-button class="b1" @click="closehandleDelete">取 消</el-button>
            <el-button class="b2" @click="handleDeleteTable">确 定</el-button>
          </span>
        </el-dialog>

        <!-- 红包停止弹框 -->
        <el-dialog
          title="提示"
          :visible.sync="outerVisibleTwo"
          width="400px"
          :before-close="closehandleDeleteTwo"
          ><img
            src="@/assets/images/tips_icon.png"
            class="tips"
            style="
              margin: 6px 0px 0px 110px;
              position: absolute;
              width: 22px;
              height: 22px;
            "
          />
          <span
            style="
              position: absolute;
              margin: 10px 0px 0px 140px;
              font-size: 14px;
            "
            >是否停止计划？</span
          >
          <span slot="footer" class="buttonBox">
            <el-button class="b1" @click="closehandleDeleteTwo"
              >取 消</el-button
            >
            <el-button class="b2" @click="handleDeleteTableTwo"
              >确 定</el-button
            >
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import topTitle from "../../components/top-title";
import inputForm from "../../components/inputForm";
import {
  jingdouList,
  jingdouAccount,
  allAccount,
  allAccountList,
  redPacketList,
  jingdouSet,
  setAccountList,
  setRedPacket,
  jignduoEcho,
  jingdouRecordList,
  modifyAssets,
  stopAssets,
  getAccountList,
  dispenseRedPacket,
  stopRedPacket,
  judgingActivation,
  stopActivity,
} from "@/api/integralCenter/prizeCenter.js";

export default {
  components: {
    topTitle,
    inputForm,
  },
  filters: {
    statusStr(status) {
      return {
        0: "未知",
        1: "未开始",
        2: "进行中",
        3: "已结束",
        null: "null",
      }[status];
    },
    showNumber(num) {
      if (num > 0) {
        return num;
      } else {
        return 0;
      }
    },
  },
  data() {
    return {
      plusCountAA: null,
      eKaCount: {
        one: null,
        five: null,
        twenty: null,
        fifty: null,
        hundred: null,
        all: null,
      },
      aqyiCount: {
        yuka: null,
        jika: null,
        bannianka: null,
        nianka: null,
      },
      detailContent: {},
      formRevise: {},
      outerVisible: false,
      outerVisibleTwo: false,
      dialogFormVisible: false,
      dialogTableJingduo: false,
      dialogDistribution: false,
      dialogRevise: false,
      rowdialog: {},
      gridDataList: [],
      dialogTitle: "创建计划",
      tabActive: 1,
      availableNum: null,
      freezeNum: "-",
      quantityFrozen: "-",
      totalList: 0,
      tableLoading: true,
      currentPage: 1, //京豆分页
      quantityTotal: "-", //累计充值数量
      quantityBalance: "-", //账户剩余
      formSet: {
        assetType: null,
        itemId: "",
        ruleType: "1",
        planName: "",
        startTime: "",
        endTime: "",
        quota: "",
        quantityTotal: "",
        descprition: "",
        sendTimes: "",
      },
      rules: {
        planName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          { min: 1, max: 10, message: "不能超过 10 个字符", trigger: "blur" },
        ],
        startTime: [
          {
            type: "datetime",
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        endTime: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        itemId: [{ required: true, message: " ", trigger: "change" }],
        descprition: [
          { required: true, message: "请填写计划内容", trigger: "blur" },
        ],
        quantityTotal: [
          { required: true, message: "请填写预算额", trigger: "blur" },
        ],
        ruleType: [
          { required: true, message: "请选择发豆规则", trigger: "change" },
        ],
        sendTimes: [
          { required: true, message: "请填写发豆次数", trigger: "blur" },
        ],
        quota: [
          { required: true, message: "请填写单份红包金额", trigger: "blur" },
        ],
      },
      formList: {
        current: 1,
        size: 10,
      },
      pointsStatus: false, //积分开通状态
      form: [
        {
          id: 0,
          pointsSetContent: "购物积分发放公式设置",
          set: "前往设置 >",
          scr: require("../../assets/images/integralCenter/gwjf.png"),
        },
        {
          id: 1,
          pointsSetContent: "赚积分规则设置",
          set: "前往设置 >",
          scr: require("../../assets/images/integralCenter/zjf.png"),
        },
        {
          id: 2,
          pointsSetContent: "积分数据分析",
          set: "前往设置 >",
          scr: require("../../assets/images/integralCenter/jfsj.png"),
        },
        {
          id: 3,
          pointsSetContent: "查询买家积分",
          set: "前往设置 >",
          scr: require("../../assets/images/integralCenter/cxjf2.png"),
        },
        {
          id: 4,
          pointsSetContent: "积分兑换优惠券",
          set: "前往设置 >",
          scr: require("../../assets/images/integralCenter/jfyhq.png"),
        },
        {
          id: 5,
          pointsSetContent: "积分兑换商品优惠",
          set: "前往设置 >",
          scr: require("../../assets/images/integralCenter/jfdh.png"),
        },
      ],
      inputData: [
        {
          name: "计划名称:",
          val: "planName",
          placeholder: "请输入",
        },
        {
          name: "计划时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault:true,
        },
        {
          name: "状态:",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            { label: "全部状态", id: 0 },
            { label: "未开始", id: 1 },
            { label: "进行中", id: 2 },
            { label: "已结束", id: 3 },
          ],
        },
      ],
      inputDataTwo: [
        {
          name: "计划名称:",
          val: "planName",
          placeholder: "请输入",
        },
        {
          name: "计划时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault:true,
        },
        {
          name: "状态:",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            { label: "全部状态", id: 0 },
            { label: "未开始", id: 1 },
            { label: "进行中", id: 2 },
            { label: "已结束", id: 3 },
          ],
        },
      ],
      inputDataThree: [
        {
          name: "计划名称:",
          val: "planName",
          placeholder: "请输入",
        },
        {
          name: "计划时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault:true,
        },
        {
          name: "状态:",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            { label: "全部状态", id: 0 },
            { label: "未开始", id: 1 },
            { label: "进行中", id: 2 },
            { label: "已结束", id: 3 },
          ],
        },
      ],
      inputDataDetail: [
        {
          name: "买家昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "创建时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault:true,
        },
      ],
      tableData: [],
      tableDataTwo: [],
      tableDataThree: [],
      ids: null,
      unit: "",
      mytimestart: "",
      mytimeend: "",
      opentime:true,
    };
  },
  computed:{
    pageName:function(){
      // if(this.tabActive == 1){
        return "忠诚度管理-资产项管理"
      // }
      // if(this.tabActive == 2){
      //   return "忠诚度管理-资产项管理-积分"
      // }
      // if(this.tabActive == 3){
      //   return "忠诚度管理-资产项管理-京东E卡"
      // }
      // if(this.tabActive == 4){
      //   return "忠诚度管理-资产项管理-爱奇艺会员"
      // }
      // if(this.tabActive == 5){
      //   return "忠诚度管理-资产项管理-plus会员"
      // }
      // if(this.tabActive == 6){
      //   return "忠诚度管理-资产项管理-现金红包"
      // }
    }
  },
  mounted() {
    this.time();
    this.quireList();
    this.accountList();
    this.judgingAct();
    if (this.$route.query.tabAct == 3) {
      this.tabActive = 3;
    } else if (this.$route.query.tabAct == 4) {
      this.tabActive = 4;
    } else if (this.$route.query.tabAct == 5) {
      this.tabActive = 5;
    } else if (this.$route.query.tabAct == 6) {
      this.tabActive = 6;
    }
    this.allSearch();
    // this.acquireAssets();
  },
  methods: {
        //时间拼装
     time() {
      let yy = new Date().getFullYear(); //当前年份
      let mm =
        new Date().getMonth() + 1 < 10
          ? "0" + (new Date().getMonth() + 1)
          : new Date().getMonth() + 1;
      let dd =
        new Date().getDate() < 10
          ? "0" + new Date().getDate()
          : new Date().getDate(); //当前天数
      this.mytimestart = this.getDateStr(-30)+` 00:00:00`;
      this.mytimeend = `${yy}-${mm}-${dd} 23:59:59`;
    },
    stopActivity(val) {
      this.$confirm("是否停止计划?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          console.log(11);
          let ids = val.id;
          stopActivity(ids).then((res) => {
            this.quireList();
            this.$message({
              type: "success",
              message: "已停止!",
            });
          });
        })
        .catch(() => {
           console.log(2);
          this.$message({
            type: "info",
            message: "已取消...",
          });
        });
    },
    eKaChange() {
      console.log(223333);
      if (this.formSet.itemId == "2" && this.formSet.quantityTotal) {
        this.eKaCount.all = this.formSet.quantityTotal * 1;
      } else if (this.formSet.itemId == "3" && this.formSet.quantityTotal) {
        this.eKaCount.all = this.formSet.quantityTotal * 5;
      } else if (this.formSet.itemId == "4" && this.formSet.quantityTotal) {
        this.eKaCount.all = this.formSet.quantityTotal * 20;
      } else if (this.formSet.itemId == "5" && this.formSet.quantityTotal) {
        this.eKaCount.all = this.formSet.quantityTotal * 50;
      } else if (this.formSet.itemId == "6" && this.formSet.quantityTotal) {
        this.eKaCount.all = this.formSet.quantityTotal * 100;
      } else if (this.formSet.itemId == "8" && this.formSet.quantityTotal) {
        this.eKaCount.all = this.formSet.quantityTotal * 15.9;
      } else if (this.formSet.itemId == "12" && this.formSet.quantityTotal) {
        this.eKaCount.all = this.formSet.quantityTotal * 46.5;
      } else if (this.formSet.itemId == "13" && this.formSet.quantityTotal) {
        this.eKaCount.all = this.formSet.quantityTotal * 86.5;
      } else if (this.formSet.itemId == "14" && this.formSet.quantityTotal) {
        this.eKaCount.all = this.formSet.quantityTotal * 158.5;
      } else if (this.formSet.itemId == "7" && this.formSet.quantityTotal) {
        this.eKaCount.all = this.formSet.quantityTotal * 188;
      }
      // console.log(this.eKaCount.all)
      // if(this.eKaCount.all == NaN){
      //   this.eKaCount.all = 0
      // }else{
      //   this.eKaCount.all = Number(this.eKaCount.all)
      // }
    },
    jumpEvent1() {
      this.tabActive = 1;
      this.$refs.i1.formSearch()
      // this.quireList();
    },
    jumpEvent() {
      this.tabActive = 3;
      this.$refs.i2.formSearch()
      this.allSearch();
    },
    jumpEvent2() {
      this.tabActive = 4;
      this.$refs.i3.formSearch()
      this.allSearch();
    },
    jumpEvent3() {
      this.tabActive = 5;
      this.$refs.i4.formSearch()
      this.allSearch();
    },
    jumpEvent4() {
      this.tabActive = 6;
     this.$refs.i5.formSearch()
      this.allSearch();
    },
    //输入框限制负数
    checkputn(e) {
      let filtered = e.target.value.replace(/^0|[^\d]/g, "");
      e.target.value = Number(filtered);
      // //下边写用户输入时需要的执行逻辑
      // if(this.ruleForm.inputprize!= filtered) {
      //     this.ruleForm.inputprize = filtered
      // }
      // 不能输入0，绑定的值如果小于1，那么输入框置空
      if (e.target.value < 1) {
        e.target.value = "";
      }
    },
    checkputn2(e) {
      let val = e.target.value.match(/^\d*(\.?\d{0,2})/g)[0];
      console.log(val);
      //  e.target.value = Number(val)
      // // 不能输入0，绑定的值如果小于1，那么输入框置空
      // if( val == "-") {
      e.target.value = val;
      // this.formSet.quota = 0.1
      // }
    },
    checkputn1() {
      // console.log("11111111")
      if (this.formSet.quota < 0.1) {
        this.formSet.quota = 0.1;
      }
    },

    //输入框限制负数
    checkputn20(e) {
      let filtered = e.target.value.replace(/^0|[^\d]/g, "");
      e.target.value = Number(filtered);
      // //下边写用户输入时需要的执行逻辑
      // if(this.ruleForm.inputprize!= filtered) {
      //     this.ruleForm.inputprize = filtered
      // }
      // 不能输入0，绑定的值如果小于1，那么输入框置空
      if (e.target.value < 1) {
        e.target.value = "";
      }
      if (e.target.value > 20) {
        e.target.value = 20;
        this.formSet.sendTimes = 20
      }
    },
    //判断开通积分
    judgingAct() {
      judgingActivation().then((res) => {
        this.pointsStatus = res.data;
        // console.log(res,11111);
      });
    },
    //开通店铺积分跳转
    openStoreIntegral() {
      window.open(
        "https://crm.shop.jd.com/crm/points/points_pointsSetting.action"
      );
    },
    //积分设置跳转
    integralSet(type) {
      switch (type) {
        case 0:
          window.open(
            "https://crm.shop.jd.com/crm/opencard/pointrule_pointSetPage.action#/integral"
          );
        case 1:
          window.open("http://crm.shop.jd.com/crm/points/points_init.action");
        case 2:
          window.open(
            "http://crm.shop.jd.com/crm/points/data_pointsData.action"
          );
        case 3:
          window.open(
            "http://crm.shop.jd.com/crm/points/data_pointsData.action"
          );
        case 4:
          window.open(
            "http://crm.shop.jd.com/crm/points/trade_pointsTrade.action"
          );
        case 5:
          window.open(
            "http://crm.shop.jd.com/crm/points/exchange_step1.action"
          );
      }
    },
    //充值跳转
    recharge() {
      if (this.tabActive == 1) {
        window.open(
          "https://prom.shop.jd.com/rest/shop/bean/accountInfo;jsessionid=FAC6FD12860DA01BBBC7D6F5CECA13E7.s1"
        );
      } else if (this.tabActive == 3) {
        window.open("http://quanyi.shop.jd.com/#/eAccount");
      } else if (this.tabActive == 4) {
        window.open("https://quanyi.shop.jd.com/#/aiqiyiAccount");
      } else if (this.tabActive == 5) {
        window.open("https://quanyi.shop.jd.com/#/plusAccount");
      } else if (this.tabActive == 6) {
        window.open("https://quanyi.shop.jd.com/#/redGiftAccount");
      }
    },
    //获取京豆数据
    quireList() {
  if (this.opentime==true) {
       this.formList.startTime = this.mytimestart;
      this.formList.endTime = this.mytimeend;
        this.opentime=false;
      }
      this.tableLoading = true;
      jingdouList(this.formList).then((res) => {
        this.tableLoading = false;
        // console.log(res, "res");
        this.tableData = res.data.records;
        this.totalList = Number(res.data.total);
      });
    },
    // 查询京豆账户余额
    accountList() {
      jingdouAccount().then((res) => {
        if (res && res.code == 1) {
          this.availableNum = res.data.availableNum;
          this.freezeNum = res.data.freezeNum;
        } else {
          this.$message.error(res.data.message);
        }
        console.log(res.data, "京豆");
      });
    },
    // 查询资产账户余额
    allSearch() {
      if (this.tabActive == 3) {
        var type = 2; //E卡
      } else if (this.tabActive == 5) {
        var type = 3; //PLUS会员
      } else if (this.tabActive == 4) {
        var type = 4; //爱奇艺会员
      } else {
        var type = 8; //红包
      }
      let sum = 0;
      let sum2 = 0;
      let sum3 = 0;
      allAccount({ type: type }).then((res) => {
        res.data.forEach((item) => {
          sum += item.quantityBalance;
        });
        res.data.forEach((item) => {
          sum2 += item.quantityTotal;
        });
        res.data.forEach((item) => {
          sum3 += item.quantityFrozen;
        });
        // console.log(res.data, 33333333333);
        if (this.tabActive == 3) {
          this.eKaCount.one = res.data[0].quantityBalance;
          this.eKaCount.five = res.data[1].quantityBalance;
          this.eKaCount.twenty = res.data[2].quantityBalance;
          this.eKaCount.fifty = res.data[3].quantityBalance;
          this.eKaCount.hundred = res.data[4].quantityBalance;
        } else if (this.tabActive == 4) {
          this.aqyiCount.yuka = res.data[0].quantityBalance;
          this.aqyiCount.jika = res.data[1].quantityBalance;
          this.aqyiCount.bannianka = res.data[2].quantityBalance;
          this.aqyiCount.nianka = res.data[3].quantityBalance;
        } else if (this.tabActive == 5) {
          this.plusCountAA = res.data[0].quantityBalance;
        } else if (this.tabActive == 6) {
          this.unit = res.data[0].unit;
        }
        this.quantityBalance = sum;
        this.quantityTotal = sum2;
        this.quantityFrozen = sum3;
      });
    },

    //查询京东E卡,爱奇艺会员,京豆PLUS会员
    acquireAssets() {
      this.tableLoading = true;
      if (this.tabActive == 3) {
        this.formList.assetType = 5; //E卡
      } else if (this.tabActive == 5) {
        this.formList.assetType = 7; //PLUS会员
      } else if (this.tabActive == 4) {
        this.formList.assetType = 6; //爱奇艺会员
      }

      allAccountList(this.formList).then((res) => {
        this.tableLoading = false;
        this.tableDataTwo = res.data.records;
    //     this.tableDataTwo = [
		// 	{
		// 		"endTime":"2021-06-20 00:00:00",
		// 		"id":"43",
		// 		"planName":"抽奖1",
		// 		"quantityActual":0,
		// 		"quantityBalance":5,
		// 		"quantityTotal":5,
		// 		"quota":"188元",
		// 		"startTime":"2021-06-05 10:29:51",
		// 		"status":2
		// 	}
		// ];

        this.totalList = Number(res.data.total);
      });
    },
    //查询红包
    redBag() {
      this.tableLoading = true;
      redPacketList(this.formList).then((res) => {
        // console.log(res.data, "res");
        this.tableLoading = false;
        this.tableDataThree = res.data.records;
        this.totalList = Number(res.data.total);
      });
    },
    //京豆查看详情
    marketNow(row) {
      this.dialogTableJingduo = true;
      let id = Number(row.id);
      jignduoEcho(id).then((res) => {
        // console.log(res, "res");
        this.rowdialog = res.data;
        this.rowdialog.ruleType = res.data.ruleType.toString();
      });
      // console.log(row.id);
    },
    //发放明细
    marketNowDetail(row) {
      this.detailContent = row;
      this.dialogDistribution = true;
      if (this.tabActive == 1) {
        this.formList.beansPlanId = Number(row.id);
        jingdouRecordList(this.formList).then((res) => {
          // console.log(res, this.formList.beansPlanId, "res");
          this.gridDataList = res.data.records;
          this.totalList = Number(res.data.total);
        });
      } else if (
        this.tabActive == 3 ||
        this.tabActive == 4 ||
        this.tabActive == 5
      ) {
        this.formList.assetPlanId = Number(row.id);
        getAccountList(this.formList).then((res) => {
          // console.log(res, this.formList.beansPlanId, "res");
          this.gridDataList = res.data.records;
          this.totalList = Number(res.data.total);
        });
      } else if (this.tabActive == 6) {
        this.formList.redPacketPlanId = Number(row.id);
        dispenseRedPacket(this.formList).then((res) => {
          // console.log(res, this.formList.redPacketPlanId, "res");
          this.gridDataList = res.data.records;
          this.totalList = Number(res.data.total);
        });
      }
    },
    //发放明细查询
    searchContentDetail(val) {
      this.formList.memberNick = val.memberNick;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.marketNowDetail(this.detailContent);
    },
    //资产修改
    marketNowSet(row) {
      this.formRevise = row;
      this.formRevise.id = Number(row.id);

      // modifyAssets(this.formRevise).then((res) => {
        // console.log(res);
        // if (res && res.code == 1) {
          this.dialogRevise = true;
        // }
      // });
      // if (this.dialogRevise == false) {
        // this.acquireAssets();
      // }
    },
    //资产修改确认
    modifyConfirmation() {
      modifyAssets(this.formRevise).then((res) => {
        // console.log(res);
        if (res && res.code == 1) {
          this.dialogRevise = false;
          // this.tableDataTwo.endTime = res.data.endTime;
          this.$message.success("修改成功");
          this.acquireAssets();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //资产停止
    marketNowStop(row) {
      this.outerVisible = true;
      this.ids = Number(row.id);
    },
    //资产停止确定
    handleDeleteTable() {
      let id = this.ids;
      stopAssets(id).then((res) => {
        if (res && res.code == 1) {
          this.$message.success("修改成功");
          this.outerVisible = false;
          this.acquireAssets();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    closehandleDelete() {
      this.outerVisible = false;
    },
    //红包停止
    marketStop(row) {
      this.outerVisibleTwo = true;
      this.ids = Number(row.id);
    },
    handleDeleteTableTwo() {
      let id = this.ids;
      stopRedPacket(id).then((res) => {
        if (res && res.code == 1) {
          this.outerVisibleTwo = false;
          this.$message.success("修改成功");
          this.redBag()();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    closehandleDeleteTwo() {
      this.outerVisibleTwo = false;
    },
    //京豆查询
    searchContent(val) {
      this.formList.current = 1;
      this.formList.planName = val.planName;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.formList.status = val.status;
      this.quireList();
    },
    //资产查询
    searchContentTwo(val) {
      // console.log(2222);
      this.formList.current = 1;
      this.formList.planName = val.planName;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.formList.status = val.status;
      this.acquireAssets();
    },
    //红包
    searchContentThree(val) {
      // console.log(333);
      this.formList.current = 1;
      this.formList.planName = val.planName;
      this.formList.startTime = val.startTime;
      this.formList.endTime = val.endTime;
      this.formList.status = val.status;
      this.redBag();
    },

    //分页变化事件
    handleSizeChange(val) {
      this.formList.size = val;
      if (this.tabActive == 1) {
        this.quireList();
      } else if (this.tabActive == 3) {
        this.acquireAssets();
      } else if (this.tabActive == 4) {
        this.acquireAssets();
      } else if (this.tabActive == 5) {
        this.acquireAssets();
      } else if (this.tabActive == 6) {
        this.redBag();
      }
    },
    handleCurrentChange(val) {
      this.formList.current = val;
      if (this.tabActive == 1) {
        this.quireList();
      } else if (this.tabActive == 3) {
        this.acquireAssets();
      } else if (this.tabActive == 4) {
        this.acquireAssets();
      } else if (this.tabActive == 5) {
        this.acquireAssets();
      } else if (this.tabActive == 6) {
        this.redBag();
      }
    },

    //创建京豆弹窗
    createPopup() {
      if (this.tabActive == 1) {
        jingdouAccount().then((res) => {
          if (res && res.code == 1) {
            this.dialogFormVisible = true;
            this.formSet.itemId = "";
          } else {
            this.$message.error(res.data.message);
          }
          console.log(res.data, "京豆");
        });
      } else {
        this.dialogFormVisible = true;
        this.formSet.itemId = "";
      }
    },
    //时间清空
    clearTimeSendTime() {
      this.formSet.startTime = "";
      this.formSet.endTime = "";
    },
    deepClone(obj) {
      let theObj = JSON.stringify(obj),
        objClone = JSON.parse(theObj);
      return objClone;
    },
    //创建京豆确定
    dialogFormSet() {
      let mes = this.deepClone(this.formSet);
      if (this.formSet.quantityTotal != null) {
        mes.quantityTotal = Number(this.formSet.quantityTotal);
      }
      if (this.formSet.ruleType != null) {
        mes.ruleType = Number(this.formSet.ruleType);
      }
      if (this.formSet.sendTimes != null) {
        mes.sendTimes = Number(this.formSet.sendTimes);
      }
      // if (this.formSet.quantityTotal > this.availableNum) {
      //   this.$message.error("余额不足");
      // }

      //京豆创建接口
      if (this.tabActive == 1) {
        jingdouSet(mes)
          .then((res) => {
            if (res && res.code == 1) {
              this.quireList();
              this.$message.success("添加成功");
              this.dialogFormVisible = false;
              this.formSet.ruleType = "";
              this.formSet.descprition = "";
              this.formSet.endTime = "";
              this.formSet.planName = "";
              this.formSet.quantityTotal = "";
              this.formSet.sendTimes = "";
              this.formSet.startTime = "";
              this.formSet.assetType = null;
            } else {
              this.formSet.ruleType = this.formSet.ruleType.toString();
              this.$message.error(res.message);
            }
          })
          .catch((res) => {
            // console.log(this.formSet.ruleType, 222);
            if (this.formSet.ruleType != null) {
              this.formSet.ruleType = this.formSet.ruleType.toString();
            }
            this.$message.error(res.message);
          });
      }
      //资产创建接口
      else if (this.tabActive == 3) {
        this.formSet.assetType = 5;
        let mes = this.deepClone(this.formSet);
        if (this.formSet.itemId != null) {
          mes.itemId = Number(this.formSet.itemId);
        }
        if (this.formSet.quantityTotal != null) {
          mes.quantityTotal = Number(this.formSet.quantityTotal);
        }
        mes.quota = this.eKaCount.all / this.formSet.quantityTotal + "元";
        setAccountList(mes)
          .then((res) => {
            // console.log(res, "res");
            if (res && res.code == 1) {
              this.acquireAssets();
              this.$message.success("添加成功");
              this.dialogFormVisible = false;
              this.formSet.descprition = "";
              this.formSet.endTime = "";
              this.formSet.itemId = null;
              this.formSet.planName = "";
              this.formSet.quantityTotal = "";
              this.formSet.quota = "";
              this.formSet.startTime = "";
              this.formSet.assetType = null;
            } else {
              this.$message.error(res.message);
            }
          })
          .catch((res) => {
            this.$message.error(res.message);
          });
      } else if (this.tabActive == 4) {
        this.formSet.assetType = 6;
        let mes = this.deepClone(this.formSet);
        if (this.formSet.itemId != null) {
          mes.itemId = Number(this.formSet.itemId);
        }
        if (this.formSet.quantityTotal != null) {
          mes.quantityTotal = Number(this.formSet.quantityTotal);
        }
        mes.quota = this.eKaCount.all / this.formSet.quantityTotal + "元";
        setAccountList(mes)
          .then((res) => {
            if (res && res.code == 1) {
              this.acquireAssets();
              this.$message.success("添加成功");
              this.dialogFormVisible = false;
              this.formSet.descprition = "";
              this.formSet.endTime = "";
              this.formSet.itemId = "";
              this.formSet.planName = "";
              this.formSet.quantityTotal = "";
              this.formSet.quota = "";
              this.formSet.startTime = "";
              this.formSet.assetType = null;
            } else {
              this.$message.error(res.message);
            }
          })
          .catch((res) => {
            this.$message.error(res.message);
          });
      } else if (this.tabActive == 5) {
        this.formSet.assetType = 7;
        let mes = this.deepClone(this.formSet);
        if (this.formSet.itemId != null) {
          mes.itemId = Number(this.formSet.itemId);
        }
        if (this.formSet.quantityTotal != null) {
          mes.quantityTotal = Number(this.formSet.quantityTotal);
        }
        mes.quota = this.eKaCount.all / this.formSet.quantityTotal + "元";
        setAccountList(mes)
          .then((res) => {
            if (res && res.code == 1) {
              this.acquireAssets();
              this.$message.success("添加成功");
              this.dialogFormVisible = false;
              this.formSet.descprition = "";
              this.formSet.endTime = "";
              this.formSet.itemId = "";
              this.formSet.planName = "";
              this.formSet.quantityTotal = "";
              this.formSet.quota = "";
              this.formSet.startTime = "";
              this.formSet.assetType = null;
            } else {
              this.$message.error(res.message);
            }
          })
          .catch((res) => {
            this.$message.error(res.message);
          });
      } else if (this.tabActive == 6) {
        let mes = this.deepClone(this.formSet);
        if (this.formSet.quota != null) {
          mes.quota = Number(this.formSet.quota);
        }
        if (this.formSet.quantityTotal != null) {
          mes.quantityTotal = Number(this.formSet.quantityTotal);
        }
        setRedPacket(mes)
          .then((res) => {
            if (res && res.code == 1) {
              this.redBag();
              this.$message.success("添加成功");
              this.dialogFormVisible = false;
              this.formSet.descprition = "";
              this.formSet.endTime = "";
              this.formSet.planName = "";
              this.formSet.quantityTotal = "";
              this.formSet.quota = "";
              this.formSet.startTime = "";
              this.formSet.assetType = null;
            } else {
              this.$message.error(res.message);
            }
          })
          .catch((res) => {
            this.$message.error(res.message);
          });
      }
    },
    //取消
    dialogFormCancel() {
      this.dialogFormVisible = false;
      this.formSet.descprition = "";
      this.formSet.endTime = "";
      this.formSet.planName = "";
      this.formSet.quantityTotal = "";
      this.formSet.quota = "";
      this.formSet.startTime = "";
      this.formSet.ruleType = "1";
      this.formSet.assetType = null;

      // this.formSet = {
      //     itemId: "",
      //     ruleType:"1",
      //     planName:"",
      //     startTime:"",
      //     endTime:"",
      //     quota:"",
      //     quantityTotal:"",
      //     descprition:"",
      //     sendTimes:"",
      //   }
    },
  },
};
</script>

<style scoped lang="scss">
.integralEden {
  box-sizing: border-box;
  padding: 0 20px;
  min-width: 1080px;
  .content {
    min-height: 980px;
    margin: 20px 0 30px 0;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    .navTab {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      padding: 0 20px;
      position: relative;
      height: 50px;
      font-size: 14px;
      color: #666;
      border-bottom: 1px solid #f6f6f6;
      .tab {
        // width: 100px;
        padding: 0 20px;
        height: 50px;
        line-height: 50px;
        position: relative;
        // padding: 0 11px;
        cursor: pointer;
        transition: all 0.2s;
      }
      .active {
        color: #fe4d45;
        &::before {
          content: "";
          position: absolute;
          left: 50%;
          bottom: 0;
          transform: translateX(-50%);
          width: 80%;
          height: 2px;
          background-color: #fe4d45;
          transition: all 0.2s;
          animation: opation 0.2s;
        }
      }
    }
    .topTis {
      display: flex;
      align-items: baseline;
      // margin: 0 30px 30px 56px;
      // margin-top: 24px;
      color: #333;
      font-size: 14px;

      background: #fffaee;
      margin: 30px;
      padding: 12px;
      color: #333;
      .desc {
        line-height: 20px;
        .setting-text {
          margin-bottom: 8px;
          span {
            font-size: 14px;
            color: #fe4d45;
            margin-left: 30px;
          }
        }
      }
      p {
        margin-left: 5px;
        line-height: 20px;
        // width: 700px;
      }
    }
    .boxLayer {
      display: flex;
      flex-wrap: wrap;
      // align-content: baseline;
      min-width: 1366px;
      box-sizing: border-box;
      padding: 30px 0;
      list-style: none;
      height: 350px;
      .boxSet {
        position: relative;
        flex: 1;
        max-width: 23.3%;
        min-width: 23.3%;
        box-sizing: border-box;
        margin: 0 14px;
        margin-bottom: 20px;
        // position: relative;
        // height: 120px;
        // width: 400px;
        border: 1px solid #eeeeee;
        border-radius: 8px;
        p {
          position: absolute;
          margin: 30px 0 10px 40px;
          color: #333333;
          font-size: 16px;
        }
        .imgTp {
          position: absolute;
          right: 0;
          // height: 60px;
          // width: 60px;
          margin: 20px 30px 0 0;
        }
        &:hover {
          background-color: #fff4f4;
          border: 1px solid #fe8f8a;
        }
      }
    }
    .dot {
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      opacity: 1;
      margin-right: 7px;
    }
    .dot-0 {
      background: #cccccc;
    }
    .dot-1 {
      background: #cccccc;
    }
    .dot-2 {
      background: #7f85e9;
    }
    .dot-3 {
      background: #fe4d45;
    }
    .operation {
      cursor: pointer;
      color: #7f85e9;
      &:hover {
        color: #fe4d45;
      }
    }
    .topTisTwo {
      display: flex;
      align-items: baseline;
      position: relative;
      background: #fafafa;
      height: 120px;
      margin: 30px;

      .beans {
        // height: 80px;
        // width: 80px;
        // border-radius: 45%;
        margin: 20px;
      }
      .btn {
        position: absolute;
        right: 0;
        width: 110px;
        margin: 45px 20px;
      }
      .available {
        position: absolute;
        padding: 40px 0 40px 140px;
        font-size: 14px;
      }
      .freeze {
        position: absolute;
        padding: 40px 0 40px 280px;
        font-size: 14px;
      }
      .count {
        position: absolute;
        padding: 40px 0 40px 400px;
        font-size: 14px;
      }
    }
    .pagination {
      margin: 40px 80px 0 0;
      text-align: right;
    }
    .buttonBox {
      .b1 {
        width: 98px;
        height: 32px;
        color: #666666;
        // position: absolute;
        border-radius: 3px;
        margin-top: 20px;
        border: 1px solid #dddddd;
        background-color: #fff;
        &:hover {
          color: #fe4d45;
          border: 1px solid #fe4d45;
          background-color: #fff4f4;
        }
        &:active {
          color: #fe4d45;
          border: 1px solid #fe4d45;
          background-color: #fff4f4;
        }
      }
      .b2 {
        width: 98px;
        // position: absolute;
        // margin-right: 80px;
        height: 32px;
        margin: 20px 80px 10px 10px;
        border: 1px solid #fe4d45;
        color: #ffffff;
        border-radius: 3px;
        background-color: #fe4d45;
        &:hover {
          color: #fff;
          opacity: 0.9;
          background-color: #fe4d45;
        }
        &:active {
          color: #fe4d45;
          border: 1px solid #fe4d45;
          background-color: #fff4f4;
        }
      }
    }
  }
}
</style>
